import type { RootState } from "types";

export const getCustomDimensionTopicListIdsForQuery = (state: RootState) =>
  state.domains.customKeyIssue.topicSearch.idsForQuery;

export const getCustomDimensionTopicListIsPending = (state: RootState) =>
  state.domains.customKeyIssue.topicSearch.isPending;

export const getDimensionUploadId = (state: RootState) => state.domains.customKeyIssue.upload.entityId;

export const getCustomKeyIssueUploadHasErrored = (state: RootState) => state.domains.customKeyIssue.upload.error;

export const getCustomKeyIssueIsActiveForm = (state: RootState) =>
  state.domains.customKeyIssue.upload.isCreateFormActive;

export const getCustomKeyIssueIsUploading = (state: RootState) => state.domains.customKeyIssue.upload.isPending;

export const getCustomKeyIssueTopicList = (state: RootState) =>
  getCustomDimensionTopicListIdsForQuery(state)[state.domains.customKeyIssue.topicSearch.currentQuery];
